import React from "react";
import PropTypes from "prop-types";
import ButtonIcon from "../../components/buttons/buttonIcon";
import * as buttonConstants from "../../components/buttons/buttonConstants";
import ButtonBar from "../../components/buttons/buttonBar";
import * as config from "../../constants/config";

const ItemBankListSearchRow = ({ itemBank, onEditItemBank, onDeleteItemBank }) => {
    const itemBankLinkList = itemBank.Links.filter(f => f.Method === config.DELETE_API_METHOD);
    let itemBankLinkInfo = {};
    if(itemBankLinkList.length > 0)
        itemBankLinkInfo = itemBankLinkList[0];

    return (
        <tr>
            <td>{itemBank.Name}</td>
            <td className={"text-center"}>{itemBank.DateCreated}</td>
            <td className={"text-center"}>{itemBank.DateModified}</td>
            <td className={"text-center"}>{itemBank.NumberOfItems}</td>
            <td className={"text-center"}>
                <ButtonBar buttonBarPosition={buttonConstants.BUTTON_BAR_POSITION_CENTER}>
                    <ButtonIcon config={{
                        name: "btnEdit",
                        label: "Edit",
                        onClick: (event) => onEditItemBank(event, itemBank.Id),
                        iconType: buttonConstants.ICON_EDIT
                    }} />
                    <ButtonIcon config={{
                        name: "btnDelete",
                        label: (itemBankLinkList.length === 0) ? "Delete not enabled due to being associated with a score" : "Delete",
                        disabled: (itemBankLinkList.length === 0),
                        onClick: (event) => onDeleteItemBank(event, itemBankLinkInfo),
                        iconType: buttonConstants.ICON_DELETE
                    }} />
                </ButtonBar>
            </td>
        </tr>
    );
};

ItemBankListSearchRow.propTypes = {
    itemBank: PropTypes.object.isRequired,
    onEditItemBank: PropTypes.func.isRequired,
    onDeleteItemBank: PropTypes.func.isRequired
};

export default ItemBankListSearchRow;